import {Filter, TextInput} from "react-admin";
import React from "react";

export const ShopifyStoreFilter = props => (
    <Filter {...props}>
        <TextInput label="Store Name" source="store_name" defaultValue="" />
        <TextInput label="Store url" source="base_url" defaultValue="" />
        <TextInput label="Subpath" source="subpath" defaultValue="" />
    </Filter>
);